module.exports = __webpack_public_path__ + "static/img/img_3.06a0997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_3.png
// module id = Ulpp
// module chunks = 0